const formatUTCDate = (value) => {
  const fechaUTC = new Date(value);

  if (Number.isNaN(fechaUTC.getTime())) return "";

  return `${fechaUTC.getUTCFullYear()}-${String(
    fechaUTC.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(fechaUTC.getUTCDate()).padStart(2, "0")} ${String(
    fechaUTC.getUTCHours()
  ).padStart(2, "0")}:${String(fechaUTC.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(fechaUTC.getUTCSeconds()).padStart(2, "0")}`;
};

const formatFaultDate = (value) => {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "tipoMaquinaControl", headerName: "Tipo de Máquina y Control", minWidth: 200, flex: 1 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },
  { field: "tempRefrEvaporado1", headerName: "Temp. Refr Evaporado Circuito 1", minWidth: 200, flex: 1 },
  { field: "tempRefrEvaporado2", headerName: "Temp. Refr Evaporado Circuito 2", minWidth: 200, flex: 1 },
  { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 180, flex: 1 },
  { field: "tempProcesoSalida", headerName: "Temp. Proceso Salida", minWidth: 180, flex: 1 },
  { field: "tempRefrCondensado1", headerName: "Temp. Refr Condensado Circuito 1", minWidth: 200, flex: 1 },
  { field: "tempRefrCondensado2", headerName: "Temp. Refr Condensado Circuito 2", minWidth: 200, flex: 1 },
  { field: "tempDescargaComp1", headerName: "Temp. Descarga Compresor 1", minWidth: 200, flex: 1 },
  { field: "tempDescargaComp2", headerName: "Temp. Descarga Compresor 2", minWidth: 200, flex: 1 },
  { field: "presionSuccionComp1", headerName: "Presión Succión Comp 1", minWidth: 200, flex: 1 },
  { field: "presionSuccionComp2", headerName: "Presión Succión Comp 2", minWidth: 200, flex: 1 },
  { field: "presionDescargaComp1", headerName: "Presión Descarga Comp 1", minWidth: 200, flex: 1 },
  { field: "presionDescargaComp2", headerName: "Presión Descarga Comp 2", minWidth: 200, flex: 1 },
  { field: "voltajeCmp1", headerName: "Voltaje Comp 1", minWidth: 150, flex: 1 },
  { field: "voltajeCmp2", headerName: "Voltaje Comp 2", minWidth: 150, flex: 1 },
  { field: "amperajeCmp1", headerName: "Amperaje Comp 1", minWidth: 150, flex: 1 },
  { field: "amperajeCmp2", headerName: "Amperaje Comp 2", minWidth: 150, flex: 1 },
  { field: "sobrecalentamientoCmp1", headerName: "Sobrecalentamiento Comp 1", minWidth: 200, flex: 1 },
  { field: "sobrecalentamientoCmp2", headerName: "Sobrecalentamiento Comp 2", minWidth: 200, flex: 1 },
  { field: "condicionActualComp1", headerName: "Condición Actual Comp 1", minWidth: 200, flex: 1 },
  { field: "condicionActualComp2", headerName: "Condición Actual Comp 2", minWidth: 200, flex: 1 },
  { field: "porcentajeCargaComp1", headerName: "Porcentaje Carga Comp 1", minWidth: 200, flex: 1 },
  { field: "porcentajeCargaComp2", headerName: "Porcentaje Carga Comp 2", minWidth: 200, flex: 1 },
  { field: "leaderSecondaryComp1", headerName: "Leader/Secondary Comp 1", minWidth: 200, flex: 1 },
  { field: "leaderSecondaryComp2", headerName: "Leader/Secondary Comp 2", minWidth: 200, flex: 1 },
  { field: "controlDeCarga", headerName: "Control de Carga", minWidth: 200, flex: 1 },
  { field: "bajoNivelAceiteComp1", headerName: "Bajo Nivel Aceite Comp 1", minWidth: 200, flex: 1 },
  { field: "bajoNivelAceiteComp2", headerName: "Bajo Nivel Aceite Comp 2", minWidth: 200, flex: 1 },
  { field: "switchFlujoAguaHelada", headerName: "Switch Flujo Agua Helada", minWidth: 200, flex: 1 },
  { field: "statusTempMotorComp1", headerName: "Status Temp Motor Comp 1", minWidth: 200, flex: 1 },
  { field: "statusTempMotorComp2", headerName: "Status Temp Motor Comp 2", minWidth: 200, flex: 1 },
  { field: "interlockComp1", headerName: "Interlock Comp 1", minWidth: 200, flex: 1 },
  { field: "interlockComp2", headerName: "Interlock Comp 2", minWidth: 200, flex: 1 },
  { field: "input07", headerName: "Input 07", minWidth: 150, flex: 1 },
  { field: "statusMotorSaver1", headerName: "Status Motor Saver 1", minWidth: 200, flex: 1 },
  { field: "statusMotorSaver2", headerName: "Status Motor Saver 2", minWidth: 200, flex: 1 },
  { field: "paroEmergencia", headerName: "Paro de Emergencia", minWidth: 200, flex: 1 },
  { field: "encendidoCompresor1", headerName: "Encendido Compresor 1", minWidth: 200, flex: 1 },
  { field: "encendidoCompresor2", headerName: "Encendido Compresor 2", minWidth: 200, flex: 1 },
  { field: "ventiladoresGrupo1", headerName: "Ventiladores Grupo 1", minWidth: 200, flex: 1 },
  { field: "ventiladoresGrupo2", headerName: "Ventiladores Grupo 2", minWidth: 200, flex: 1 },
  { field: "ventiladoresGrupo3", headerName: "Ventiladores Grupo 3", minWidth: 200, flex: 1 },
  { field: "ventiladoresGrupo4", headerName: "Ventiladores Grupo 4", minWidth: 200, flex: 1 },
  { field: "ventiladoresGrupo5", headerName: "Ventiladores Grupo 5", minWidth: 200, flex: 1 },
  { field: "ventiladoresGrupo6", headerName: "Ventiladores Grupo 6", minWidth: 200, flex: 1 },
  { field: "ventiladoresGrupo7", headerName: "Ventiladores Grupo 7", minWidth: 200, flex: 1 },
  { field: "ventiladoresGrupo8", headerName: "Ventiladores Grupo 8", minWidth: 200, flex: 1 },
  { field: "fechaFalla1", headerName: "Fecha Falla 1", minWidth: 200, flex: 1 },
  { field: "numeroFalla1", headerName: "Número de Falla 1", minWidth: 200, flex: 1 },
  { field: "fechaFalla2", headerName: "Fecha Falla 2", minWidth: 200, flex: 1 },
  { field: "numeroFalla2", headerName: "Número de Falla 2", minWidth: 200, flex: 1 },
  { field: "fechaFalla3", headerName: "Fecha Falla 3", minWidth: 200, flex: 1 },
  { field: "numeroFalla3", headerName: "Número de Falla 3", minWidth: 200, flex: 1 },
  { field: "fechaFalla4", headerName: "Fecha Falla 4", minWidth: 200, flex: 1 },
  { field: "numeroFalla4", headerName: "Número de Falla 4", minWidth: 200, flex: 1 },
  { field: "fechaFalla5", headerName: "Fecha Falla 5", minWidth: 200, flex: 1 },
  { field: "numeroFalla5", headerName: "Número de Falla 5", minWidth: 200, flex: 1 },
  { field: "tiempoServicioHoras", headerName: "Tiempo de Servicio Horas", minWidth: 200, flex: 1 },
  { field: "horasTotalesOperacion", headerName: "Horas Totales Operación", minWidth: 200, flex: 1 },
];

const mapRow = (row, index) => ({
  id: index + 1,
  tipoMaquinaControl: row["Tipo de Máquina y Control"],
  numeroEquipo: row["Número de Equipo"],
  fecha: formatUTCDate(row["Fecha"]),
  tempRefrEvaporado1: row["Temp. Refr Evaporado Circuito 1"],
  tempRefrEvaporado2: row["Temp. Refr Evaporado Circuito 2"],
  tempProcesoEntrada: row["Temp. Proceso Entrada"],
  tempProcesoSalida: row["Temp. Proceso Salida"],
  tempRefrCondensado1: row["Temp. Refr Condensado Circuito 1"],
  tempRefrCondensado2: row["Temp. Refr Condensado Circuito 2"],
  tempDescargaComp1: row["Temp. Descarga Compresor 1"],
  tempDescargaComp2: row["Temp. Descarga Compresor 2"],
  presionSuccionComp1: row["Presion Succion Comp 1"],
  presionSuccionComp2: row["Presion Succion Comp 2"],
  presionDescargaComp1: row["Presion Descarga Comp 1"],
  presionDescargaComp2: row["Presion Descarga Comp 2"],
  voltajeCmp1: row["Voltaje Cmp 1"],
  voltajeCmp2: row["Voltaje Cmp 2"],
  amperajeCmp1: row["Amperaje Cmp 1"],
  amperajeCmp2: row["Amperaje Cmp 2"],
  sobrecalentamientoCmp1: row["Sobrecalentamiento Cmp 1"],
  sobrecalentamientoCmp2: row["Sobrecalentamiento Cmp 2"],
  condicionActualComp1: row["Condicion Actual Comp 1"],
  condicionActualComp2: row["Condicion Actual Comp 2"],
  porcentajeCargaComp1: row["Porcentaje Carga Comp 1"],
  porcentajeCargaComp2: row["Porcentaje Carga Comp 2"],
  leaderSecondaryComp1: row["Leader / Secondary Comp 1"],
  leaderSecondaryComp2: row["Leader / Secondary Comp 2"],
  controlDeCarga: row["Control de Carga"],
  bajoNivelAceiteComp1: row["Bajo Nivel Aceite Comp. 1"],
  bajoNivelAceiteComp2: row["Bajo Nivel Aceite Comp. 2"],
  switchFlujoAguaHelada: row["Switch Flujo Agual Helada"],
  statusTempMotorComp1: row["Status Temp Motor Comp. 1"],
  statusTempMotorComp2: row["Status Temp Motor Comp. 2"],
  interlockComp1: row["Interlock Comp. 1"],
  interlockComp2: row["Interlock Comp. 2"],
  input07: row["Input_07"],
  statusMotorSaver1: row["Status MotorSaver 1"],
  statusMotorSaver2: row["Status MotorSaver 2"],
  paroEmergencia: row["Paro_Emergencia"],
  encendidoCompresor1: row["Encendido Compresor 1"],
  encendidoCompresor2: row["Encendido Compresor 2"],
  ventiladoresGrupo1: row["Ventiladores Grupo 1"],
  ventiladoresGrupo2: row["Ventiladores Grupo 2"],
  ventiladoresGrupo3: row["Ventiladores Grupo 3"],
  ventiladoresGrupo4: row["Ventiladores Grupo 4"],
  ventiladoresGrupo5: row["Ventiladores Grupo 5"],
  ventiladoresGrupo6: row["Ventiladores Grupo 6"],
  ventiladoresGrupo7: row["Ventiladores Grupo 7"],
  ventiladoresGrupo8: row["Ventiladores Grupo 8"],
  fechaFalla1: formatFaultDate(row["Fecha de Falla 1"]),
  numeroFalla1: row["Numero de Falla 1"],
  fechaFalla2: formatFaultDate(row["Fecha de Falla 2"]),
  numeroFalla2: row["Numero de Falla 2"],
  fechaFalla3: formatFaultDate(row["Fecha de Falla 3"]),
  numeroFalla3: row["Numero de Falla 3"],
  fechaFalla4: formatFaultDate(row["Fecha de Falla 4"]),
  numeroFalla4: row["Numero de Falla 4"],
  fechaFalla5: formatFaultDate(row["Fecha de Falla 5"]),
  numeroFalla5: row["Numero de Falla 5"],
  tiempoServicioHoras: row["Tiempo de Servicio en Horas"],
  horasTotalesOperacion: row["Horas Totales de Operación"],
});

export const ezchiller2compConsultaConfig = {
  title: "ezChiller 2 Comp",
  endpoint:
    "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/ezChiller2comp/datos",
  buildRequestBody: ({ idEquipo, fechaInicio, fechaFinal }) => ({
    idEquipo,
    fechaInicio,
    fechaFinal,
    tipoMaquina: "ezChiller 2Comp",
    tipoConsulta: "Datos",
  }),
  columns,
  mapRow,
};